import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useUpdateClientDashboard } from '@/queries/clientDashboards'
import { extractErrorMessage } from '@/queries/ticketMutations'
import { CADENCE_LABELS } from '@/types/clientDashboard'
import type { Cadence, ClientDashboard } from '@/types/clientDashboard'

const selectClass =
  'h-[var(--etn-control-height-input)] w-full max-w-xs rounded-etn-pill border border-etn-border-input bg-etn-surface px-4 text-etn-control text-etn-text-cell'

export function CadenceEditor({ dashboard }: { dashboard: ClientDashboard }) {
  const update = useUpdateClientDashboard(dashboard.companyId)
  const saved = dashboard.cadence ?? ''
  const [draft, setDraft] = useState<string | null>(null)
  const cadence = draft ?? saved

  async function save() {
    try {
      await update.mutateAsync({ cadence: (cadence || null) as Cadence | null })
      setDraft(null)
      toast.success('Cadence saved')
    } catch (err) {
      toast.error(extractErrorMessage(err, 'Could not save the cadence'))
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cadence</CardTitle>
        <CardDescription>How often we meet this client.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <select aria-label="Cadence" className={selectClass} value={cadence} onChange={e => setDraft(e.target.value)}>
          <option value="">Not set</option>
          {Object.entries(CADENCE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <div>
          <Button onClick={save} disabled={cadence === saved || update.isPending}>
            Save cadence
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
